import React from 'react';
import { Link, TableRow, TableCell, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const GlobalBlackListItem = ({
  entryId,
  number,
  date,
  onClick,
  isGodAdmin,
  onDelete,
}) => {
  return (
    <TableRow key={entryId}>
      <TableCell>{entryId}</TableCell>
      <TableCell>
        <Link tabIndex={0} onClick={onClick}>
          {number}
        </Link>
      </TableCell>
      <TableCell>{date}</TableCell>
      <TableCell>
        {isGodAdmin && (
          <IconButton
            onClick={() => {
              onDelete(entryId);
            }}
            sx={{ padding: 0 }}>
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </TableCell>
    </TableRow>
  );
};

export default GlobalBlackListItem;
